import { SecurityQuestionDto } from '../../interfaces/Dto/SecurityQuestionDto';
import { SecurityQuestion } from '../../interfaces/SecurityQuestion';

export default function transformSecurityQuestion(securityQuestionDto: SecurityQuestionDto): SecurityQuestion {
  const securityQuestion = {
    active: securityQuestionDto?.active,
    answer: securityQuestionDto?.answer,
    code: securityQuestionDto?.code,
    question: securityQuestionDto?.question,
  };
  return securityQuestion;
}
